export * from "./deferredDeepLink__lookup";
export * from "./deferredDeepLink__get";

// i18n certified - complete
